<template>
    <div class="nodata">
        <div v-if="loading" class="loading"></div>
        <template v-else>
            <div class="empty" :style="iconBgStyle"></div>
            <div class="empty-text">{{ text }}</div>
        </template>
    </div>
</template>
<script>

export default {
    name: 'nodata',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '目前暂无内容哦~',
        },
    },
    computed: {
        iconBgStyle() {
            return this.icon && { backgroundImage: `url(${this.icon})` };
        },
    },
};
</script>
<style lang="less" scoped>
.nodata {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .empty {
        width: 1.02rem;
        height: 1.02rem;
        background-image: url(../../../assets/images/empty.png);
        background-repeat: no-repeat;
        background-size: contain;
    }
    .empty-text {
        margin-top: 0.12rem;
        padding-bottom: 0.6rem;
        font-size: 0.14rem;
        color: #9c9c9c;
        font-weight: 500;
        line-height: 0.17rem;
    }
    .loading {
        width: 0.4rem;
        height: 0.4rem;
        margin: 0 auto;
        background: url(../../../assets/images/loading.svg) no-repeat;
        background-size: contain;
    }
}
</style>
